import useKeyPress from "../../../../hooks/useKeyPress/index.js";
import { SINGLE as ONE } from "../../../../constants/numbers.consts.js";
export const useSearchKeyPress = ({ results, resultsLength, escapeDisabled, payload, maxResultsAmount, submitHandler, resetSelectedHandler, closeOnSubmit, selectedIndex, clear, close, setSelectedIndex, searchValue, }) => {
    useKeyPress({
        char: "/",
        withCommandKey: true,
        payload,
    });
    useKeyPress({
        char: "Escape",
        disabled: escapeDisabled,
        payload,
    });
    return {
        keyDownHandler: (e) => {
            const length = Math.min(resultsLength, maxResultsAmount);
            switch (e.key) {
                case "ArrowDown": {
                    e.preventDefault();
                    return setSelectedIndex((prevIndex) => (prevIndex < length - ONE ? prevIndex + ONE : 0));
                }
                case "ArrowUp": {
                    e.preventDefault();
                    return setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - ONE : length - ONE));
                }
                case "Enter": {
                    e.preventDefault();
                    if (selectedIndex === -1) {
                        submitHandler(searchValue);
                    }
                    else {
                        results?.[selectedIndex]?.payload?.(clear);
                        resetSelectedHandler();
                        if (closeOnSubmit)
                            close();
                    }
                    break;
                }
                default:
                    return resetSelectedHandler();
            }
        },
    };
};
export default useSearchKeyPress;
